// Copyright (c) 2016 Deere & Company

import {fetchLaborStatsReport, resetLaborStats} from './report';
import {sharedActionCreators} from '../../shared/action-creators';
import {updateLaborStatsSearchCriteria} from './criteria';

export default {
    fetchLaborStatsReport,
    resetLaborStats,
    updateLaborStatsSearchCriteria,
    ...sharedActionCreators
};



// WEBPACK FOOTER //
// ./src/reports/labor-stats/action-creators/index.js